import React from 'react';
import { CONFIG } from '../gameData';

function HowToPlayDialog({ show, onClose }) {
  if (!show) return null;

  return (
    <dialog open={show} className="howto-dialog">
      <h2>How to Play</h2>

      <p className="howto-objective">
        You've got <strong>{CONFIG.maxDays} days</strong> to turn{' '}
        <strong>$1,000</strong> (and a {`$${CONFIG.startingDebt}`} debt) into the biggest
        fortune on the streets. Your score is your <strong>Net Worth</strong>{' '}
        (cash + assets − debt). Crack the Top 10 to land on the leaderboard.
      </p>

      <ul className="howto-list">
        <li><span aria-hidden="true">💊</span> <strong>Deal smart.</strong> Buy drugs where they're cheap, sell where they're pricey — every borough and every day has different prices. That spread is your profit.</li>
        <li><span aria-hidden="true">🎒</span> <strong>Mind your stash.</strong> You can only carry {CONFIG.inventoryCapacity} units at once, so pick your loads.</li>
        <li><span aria-hidden="true">🗓️</span> <strong>Time is money.</strong> Traveling or ending the day burns a day, rerolls prices, and grows your debt {Math.round(CONFIG.dailyInterest * 100)}% per day.</li>
        <li><span aria-hidden="true">🚨</span> <strong>Watch the heat.</strong> Traveling can trigger police. Pay the fine, bribe, or run — but get caught running and you can lose your cash and stash. Your assets are never touched.</li>
        <li><span aria-hidden="true">🏦</span> <strong>Assets are safe money.</strong> Apartments &amp; businesses grow in value and survive busts; cars &amp; mansions look good but lose value. Park profits in assets to shield them.</li>
        <li><span aria-hidden="true">💵</span> <strong>Debt bites.</strong> Borrow to fund big buys, but repay fast — interest compounds hard.</li>
      </ul>

      <p className="howto-tip">
        <strong>Pro tip:</strong> keep cash working in drugs, shelter the rest in assets, and don't run heavy when the cops are out.
      </p>

      <div className="dialog-buttons">
        <button className="primary-button" onClick={onClose}>Let's go</button>
      </div>
    </dialog>
  );
}

export default HowToPlayDialog;
